export const baseUrl = process.env.REACT_APP_BASE_URL;
export const envType = process.env.REACT_APP_ENV;
